import classNames from 'classnames';
import React, { FC, PropsWithChildren } from 'react';

import styles from './PopupFooter.style.m.css';

interface IPopupFooterProps {
  readonly className?: string;
}

export const PopupFooter: FC<PropsWithChildren<IPopupFooterProps>> = ({ className, children }) => {
  return <div className={classNames(styles.container, className)}>{children}</div>;
};
